import { render } from "./UserProvider.vue?vue&type=template&id=b0cc274a&scoped=true&ts=true"
import script from "./UserProvider.vue?vue&type=script&lang=ts"
export * from "./UserProvider.vue?vue&type=script&lang=ts"

import "./UserProvider.vue?vue&type=style&index=0&id=b0cc274a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2816855756/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0cc274a"]])

export default __exports__